import ChartApp from '../chart/app';

angular.module('webtrader').component('tradingView', {
  bindings: {
    classes: '=',
  },
  transclude: false,
  templateUrl: BASE_URL+'templates/component.tradingView.html',
  controller: function ($rootScope, TradingViewFeedAdapter, Account, Quotes, Feed, Trades) {
    if (Account.info.group.is_options) {
      this.chartApp = new ChartApp(Quotes, Trades, Account, Feed);
      $rootScope.$on('quotes:select', (event, symbol) => {
        this.chartApp.changeSymbol(symbol);
      })
    }
    else{
      this.widget = new TradingView.widget({
        width: '100%',
        height: '100%',
        symbol: Quotes.currentSymbol,
        interval: Account.getVar("tvInterval") || 1,
        container_id: "tv-widget",
        datafeed: new TradingViewFeedAdapter(),
        library_path: '/static/webtrader/charting_library/',
        enabled_features: ["narrow_chart_enabled"],
        studies_access: {
          type: "black",
          tools: [{
            name: "Chaikin Oscillator",
            grayed: false
          }, {
            name: "Volume Oscillator",
            grayed: false
          }, {
            name: "Klinger Oscillator",
            grayed: false
          }]
        }
      })

      let currentSymbol = Quotes.currentSymbol
      this.widget.onSymbolChange((info) => {
        currentSymbol = info.name
        Quotes.selectSymbol(info.name)
      })

      this.widget.onIntervalChange((interval) => {
        Account.setVar("tvInterval", interval)
      })

      $rootScope.$on('quotes:select', (event, symbol) => {
        if (currentSymbol != symbol)
          this.widget.setSymbol(symbol, Account.getVar("tvInterval") || "D")
      })
    }
  }
})


angular.module('webtrader').service('TradingViewFeedAdapter', (Feed, Quotes, Account, $http, $log) => {
  class TradingViewFeedAdapter {
    constructor() {
      this.subscribes = {}
      this.lastBars = {}
      this.exchanges = [{
        value: "", name: "All"
      }]
      for(let group of Quotes.groupes)
        this.exchanges.push({value: group, name: group})
      this.symbols = []
      for(let quote of Quotes.objects)
        if (quote.tradable)
          this.symbols.push({
            description: quote.description,
            exchange: quote.group,
            full_name: quote.symbol,
            params: [],
            value: quote.symbol,
            symbol: quote.symbol,
            ticker: quote.symbol,
            // #type: if item.config.group.toUpperCase().indexOf('FOREX') isnt -1 then "forex",
          })
    }

    log(message) {
      $log.debug('TradingViewFeedAdapter:', message)
    }

    onReady(cb) {
      cb({
        "exchanges": this.exchanges,
        "supported_resolutions": ["1M", "1W", "1D", 240, 60, 30, 15, 5, 1],
      })
    }

    searchSymbolsByName(userInput, exchange, symbolType, cb) {
      cb(_(this.symbols).filter((o) => {
        return !exchange.length || o.exchange == exchange
      }).filter((o) => {
        return !userInput.length || ~o.symbol.indexOf(userInput.toUpperCase())
      }).cloneDeep())
    }

    resolveSymbol(symbol_name, cb, cbErr) {
      if (!Quotes.mapping[symbol_name])
        return cbErr("unknown_symbol")

      cb({
        name: symbol_name,
        "exchange-traded": "FOREX",
        "exchange-listed": "FOREX",
        timezone: "Europe/Moscow",
        pricescale: Quotes.mapping[symbol_name].price_scale,
        minmov: 1,
        minmove2: 0,
        has_intraday: true,
        // "intraday_multipliers": [1, 5, 15, 30, 60, 240],
        has_weekly_and_monthly: true,
        has_no_volume: true,
        ticker: symbol_name,
        description: symbol_name,
        session: "24x7",
        data_status: "streaming",
        // "regular_session": <Optional. regular trading hours.>
        type: "forex", //"type": "stock" | "futiljsures" | "bitcoin" | "forex" | "index"
      })
    }

    getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, cb, cbErr) {
      $http.get(Account.BASE_URL+'/symbol_history/', {
        params: {
          symbol: symbolInfo.name,
          resolution: resolution,
          from: rangeStartDate,
          to: rangeEndDate
        }
      }).then((res) => {
        cb(res.data)

        let key = `${symbolInfo.name}.${resolution}`
        let bar = _.last(res.data)
        this.lastBars[key] = (!this.lastBars[key] || bar.time > this.lastBars[key].time)? bar : this.lastBars[key]
      }).catch((res) => cbErr(res.data))
    }

    subscribeBars(symbolInfo, resolution, cb, listenerGUID) {
      this.log(`subscribe to ${listenerGUID}`)
      let key = `${symbolInfo.name}.${resolution}`
      this.subscribes[listenerGUID] = (symbol, data) => {
        if(symbol != symbolInfo.name)
          return

        let periodLength = resolution
        if (resolution == 'M')
          periodLength = 30 * 24 * 60
        else if (resolution == 'W')
          periodLength = 7 * 24 * 60
        else if (resolution == 'D')
          periodLength = 24 * 60
        periodLength = periodLength * 60 * 1000

        /* Since last bar is always good one with time equal to needed period
           we can rely on it. So, we can say that difference between last bar time
           and current bar time could be taken to calculate period of current bar.
           Main advantage of this is that last bar can be in any timezone and we
           can skip calculate of timezone for new period.
         */
        let offset = data.time*1000 - this.lastBars[key].time
        offset -= offset % periodLength
        let period = this.lastBars[key].time + offset

        let isNewBar = period > this.lastBars[key].time
        this.lastBars[key] = {
          time: period,
          close: data.bid,
          open: isNewBar? data.bid : this.lastBars[key].open,
          high: (isNewBar || this.lastBars[key].high < data.bid)? data.bid : this.lastBars[key].high,
          low: (isNewBar || this.lastBars[key].low > data.bid)? data.bid : this.lastBars[key].low,
        }
        cb(this.lastBars[key])
      }
      this.currentLGUID = listenerGUID
      this.subscribes[listenerGUID] = this.subscribes[listenerGUID].bind(this)
      Feed.stream.on('quote', this.subscribes[listenerGUID])
    }

    unsubscribeBars(listenerGUID) {
      // Currently TV library has bug, listenerGUID is not an old ID, but new one
      // this.log(`unsubscribe by ${listenerGUID}`, this.subscribes[listenerGUID])
      // Feed.stream.removeListener('quote', this.subscribes[listenerGUID])
      // delete this.subscribes[listenerGUID]
      this.log(`unsubscribe by ${this.currentLGUID}`)
      if (this.subscribes[this.currentLGUID]) {
        Feed.stream.removeListener('quote', this.subscribes[this.currentLGUID])
        delete this.subscribes[this.currentLGUID]
      }
    }

  }
  return TradingViewFeedAdapter
})